import { includes, without } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const toggleItemsToDelete = (id, idsToDelete) => {
	return includes(id, idsToDelete) ? without([id], idsToDelete) : [...idsToDelete, id];
};

export const initialState = {
	sort: '',
	documents: [],
	documentIdsToDelete: [],
};

const reducerMap = {
	[types.SET_SORT]: (state, { payload }) => {
		return {
			...state,
			sort: payload.sort,
		};
	},
	[types.TOGGLE_DOCUMENT_TO_DELETE]: (state, { payload }) => {
		return {
			...state,
			documentIdsToDelete: toggleItemsToDelete(payload.id, state.documentIdsToDelete),
		};
	},
	[types.SET_DOCUMENTS]: (state, { payload }) => {
		const { documents } = payload;

		return {
			...state,
			documents,
			documentIdsToDelete: [],
		};
	},
	[types.APPEND_DOCUMENTS]: (state, { payload }) => {
		const { documents } = payload;

		return {
			...state,
			documents: state.documents.concat(documents),
		};
	},
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
